import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.player = this.el.querySelector('[data-playlist-player]');
        this.poster = this.el.querySelector('[data-playlist-poster]');
        this.embed = this.el.querySelector('[data-playlist-embed]');
        this.playButton = this.el.querySelector('[data-playlist-play]');
        this.currentTitle = this.el.querySelector('[data-playlist-current-title]');
        this.currentDescription = this.el.querySelector('[data-playlist-current-description]');
        this.items = Array.from(this.el.querySelectorAll('[data-playlist-item]'));
        this.currentIndex = 0;
    }

    init() {
        if (!this.player || this.items.length === 0) {
            return;
        }

        this.items.forEach((item, index) => {
            item.addEventListener('click', () => this.select(index, true));
        });

        this.playButton.addEventListener('click', () => this.play());

    }

    select(index, shouldPlay = false) {
        const item = this.items[index];

        if (!item) {
            return;
        }

        this.stop();
        this.currentIndex = index;

        this.items.forEach((playlistItem, itemIndex) => {
            const isCurrent = itemIndex === index;
            playlistItem.classList.toggle('-current', isCurrent);
            playlistItem.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
        });

        this.poster.src = item.dataset.videoPoster;
        this.playButton.setAttribute('aria-label', `Lire la vidéo : ${item.dataset.videoTitle}`);
        if (this.currentTitle) {
            this.currentTitle.textContent = item.dataset.videoTitle;
        }
        if (this.currentDescription) {
            const description = item.dataset.videoDescription || '';
            this.currentDescription.textContent = description;
            this.currentDescription.classList.toggle('-empty', !description.trim());
        }

        if (shouldPlay) {
            this.play();
        }
    }

    play() {
        const item = this.items[this.currentIndex];
        const videoId = item ? item.dataset.videoId : '';

        if (!/^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
            return;
        }

        this.stop();

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
        iframe.title = item.dataset.videoTitle;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;

        this.embed.appendChild(iframe);
        this.player.classList.add('-playing');
    }

    stop() {
        if (this.embed) {
            this.embed.replaceChildren();
        }

        this.player.classList.remove('-playing');
    }

}
